<template>
  <ul class="g-header-nav">
    <li v-for="nav in navList" :class="{'active': actived == nav.key}">
      <a :href="nav.url" :target="nav.target || '_self'" rel="opener">
        <span class="nav-inner-text">{{ nav.name }}<span class="bage-icon" v-if="nav.bage">{{ nav.bage }}</span></span>
      </a>
    </li>
    <li v-if="showCreate && !hasNewFeat && isShowCreateBtn">
      <el-tooltip :disabled="isEditing != 1" content="账户审核通过后才可创建广告" placement="bottom" effect="light">
        <el-button type="primary" :disabled="isEditing == 1" size="small" @click="openCreate">创建广告</el-button>
      </el-tooltip>
    </li>
    <li v-if="showCreate && hasNewFeat">
      <el-dropdown placement="bottom" @visible-change="onVisibleChange">
        <span>
          创建广告
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="nav-dropdown">
          <el-dropdown-item v-if="adType == 'schema'"><a class="el-link el-link--default" href="/emi-frontend/adManagement/create" :underline="false" @click="onCreateClick('3.0_pageheader_4.0version_create')">4.0版高效创建<el-tag type="warning" size="small">推荐</el-tag></a></el-dropdown-item>
          <el-dropdown-item v-if="adType == 'push'"><a class="el-link el-link--default" href="/emi-frontend/adManagement/push/create" :underline="false" @click="onCreateClick('3.0_pageheader_4.0version_create')">4.0推送广告</a></el-dropdown-item>
          <el-dropdown-item v-if="isShowCreateBtn"><a class="el-link el-link--default" href="/v2/dist/plan.html#/create" :underline="false" @click="onCreateClick('3.0_pageheader_3.0version_create')">3.0版创建</a></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'nav-list',
    props: {
      navList: Array,
      actived: String,
      showCreate: Boolean,
      isEditing: Number,
      hasNewFeat: Boolean,
      userInfo: Object
    },
    methods: {
      onCreateClick(name) {
        this.$log && this.$log('click', {
          element_name: name
        });
      },
      onVisibleChange(val) {
        if (val) {
          this.$log && this.$log('expose', {
            element_name: '3.0_pageheader_create'
          });
        }
      },
      openCreate() {
        if (this.isEditing == 1) return;
        let url = '/v2/dist/plan.html#/ad/create';
        window.open(url);
      }
    },
    computed: {
      adType () {
        // 判断当前账户是推送广告还是竞价广告
        if (this.userInfo && this.userInfo.accounts && this.userInfo.accounts[0]) {
          const privilege = this.userInfo.accounts[0].privilege;
          if (privilege.pushAd && privilege.emi4) return 'push'
          return 'schema'
        }
        return 'schema';
      },
      isShowCreateBtn () {
        // NORMAL:正常 STOP_CREATE_AND_UPDATE:停止创建和更新 STOP_CREATE:停新建
        if (this.userInfo?.currentUser?.adCreateStatus !== 'NORMAL') return false;
        return true;
      }
    }
  }
</script>